import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { Box, AppBar, Toolbar, Typography, Button, IconButton, Menu, MenuItem, Avatar } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle'; // Icon for the avatar
import { useUser } from '@/contexts/UserContext';

export default function AdminLayout() {
  // Simulate authentication status
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Set to true for logged-in, false for logged-out
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null); // State for the menu anchor
  const {user} = useUser();
  const [displayName, setDisplatName] = useState("");

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    window.location.href = user?.logout_url || '/';
  };

  const handleLogin = () => {
    window.location.href = user?.login_url || '';
  };

  useEffect(() => {
    setDisplatName(user?.display_name || "")
  }, [user]);

  return (
    <Box sx={{ display: 'flex' }}>
      <AdminSidebar />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <AppBar position="static" sx={{ bgcolor: '#ffffff', color: '#2c3e50', boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {/* You can add a title or breadcrumbs here if needed */}
            </Typography>
            {(user?.user_login == null || typeof user?.user_login == "undefined") ? (
              <Button color="inherit" onClick={handleLogin}>Login</Button>
            ) : (
              <div>
                {/* <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <Avatar sx={{ bgcolor: '#2c3e50' }}></Avatar>
                </IconButton> */}
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleMenu}
                  color="primary"
                  title={displayName}
                  sx={{
                    textTransform: "none",
                    // borderRadius: "30px",
                    "& .MuiTypography-root": {
                      color: "white",
                    },
                    fontFamily: "Roboto",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "19px",
                    // maxWidth: '200px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                  }}
                >
                  <Typography variant="h6" noWrap component="div" ml={1}>
                    {displayName}
                  </Typography>
                </Button>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  // anchorOrigin={{
                  //   vertical: 'bottom',
                  //   horizontal: 'right',
                  // }}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </div>
            )}
          </Toolbar>
        </AppBar>
        <Box component="main" sx={{ flexGrow: 1, bgcolor: '#f5f6fa', minHeight: 'calc(100vh - 64px)', p: 4 }}> {/* Adjusted minHeight */}
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}